import { render, staticRenderFns } from "./MultiLanguageInfo.vue?vue&type=template&id=62f9abb4&scoped=true"
import script from "./MultiLanguageInfo.vue?vue&type=script&lang=js"
export * from "./MultiLanguageInfo.vue?vue&type=script&lang=js"
import style0 from "./MultiLanguageInfo.vue?vue&type=style&index=0&id=62f9abb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_css-loader@6.11.0_webpack@5.100.1__lodash@4.17.21_3wbwi6es6qkhix4tqpj2wcthvi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f9abb4",
  null
  
)

export default component.exports